/**
 * The Daily Drop's one rule, in words, and the question asked before it is spent (04 §11).
 * Shared by the Daily Drop screen and the daily briefing - a module of its own because screens
 * never import each other (flow.ts).
 */

import type { Ctx } from '../context';
import { confirm } from '../widgets/confirm';

export const ONE_ATTEMPT_LINES = [
  'ONE ATTEMPT. THE DAY IS MARKED AS FLOWN THE MOMENT THE AIRCRAFT LEAVES.',
  'QUITTING, CRASHING OR CLOSING THE WINDOW DOES NOT GIVE IT BACK. PAUSING HIDES THE GROUND.',
];

/**
 * `deployDaily` spends the day the instant it is called, so the player is asked first - one of
 * the few places the menus do (08 §5.3: only where the loss is permanent). Focus starts on the
 * way out. `unread`: he has not been through the briefing, where the special rules are.
 */
export function confirmDailyFlight(ctx: Ctx, unread: boolean, onConfirm: () => void): void {
  const lines = [...ONE_ATTEMPT_LINES];
  if (unread) lines.push('THE ORDER IS UNDER BRIEFING. EVERY MISSION HAS A RULE OF ITS OWN: READ IT FIRST.');
  confirm(ctx, {
    title: "FLY TODAY'S DROP?",
    lines,
    confirmLabel: 'FLY - SPEND THE ATTEMPT',
    cancelLabel: 'NOT YET',
    danger: true,
    onConfirm,
  });
}
